// extracted by mini-css-extract-plugin
export default {"shop-header":"shop-header_shop-header__hexpG","fixed-header":"shop-header_fixed-header__jQczt","menu":"shop-header_menu__CGzPe"};